import {dom, library} from '@fortawesome/fontawesome-svg-core'
import {icons} from 'virtual:font-awesome-icons'

export function registerFontAwesomeIcons() {
  library.add(...icons)
  dom.watch()
}
